<template>
    <div class="grid grid-cols-24 mb-24 z-0">
        <div class="sui-layout col-start-3 col-end-23">
            <div v-if="searchState.wasSearched" class="">
                <div class="flex flex-col gap-8 md:gap-16 mb-12 md:mb-24">
                    <div class="mt-8 md:mt-16">
                        <div
                            class="flex flex-col gap-8 bg-white px-8 py-3 rounded shadow-md mt-16 z-30"
                        >
                            <SearchHeaderBrand
                                v-model="searchInputValue"
                                :suggestions="suggestions"
                                @submit="handleFormSubmit"
                                @input="fetchAutocompleteSuggestions"
                            />

                            <div
                                class="flex flex-row justify-between gap-8 flex-wrap"
                            >
                                <SearchFacet
                                    :checked="Gruppenname"
                                    :facet="searchState.facets.Gruppenname"
                                    :facet-title="'Group'"
                                    @change="
                                        handleFacetChange($event, 'Gruppenname')
                                    "
                                    @reset-facet="resetFacet('Gruppenname')"
                                />

                                <!-- <SearchFacet
                                    :checked="Verpackungsgruppe"
                                    :facet="
                                        searchState.facets.Verpackungsgruppe
                                    "
                                    :facet-title="'Packaging group'"
                                    @change="
                                        handleFacetChange(
                                            $event,
                                            'Verpackungsgruppe',
                                        )
                                    "
                                    @reset-facet="
                                        resetFacet('Verpackungsgruppe')
                                    "
                                /> -->

                                <SearchFacet
                                    :checked="VerkaufsME"
                                    :facet="searchState.facets.VerkaufsME"
                                    :facet-title="'Sales unit'"
                                    @change="
                                        handleFacetChange($event, 'VerkaufsME')
                                    "
                                    @reset-facet="resetFacet('VerkaufsME')"
                                />

                                <SearchFacet
                                    :checked="Reinheit"
                                    :facet="searchState.facets.Reinheit"
                                    :facet-title="'Purity'"
                                    @change="
                                        handleFacetChange($event, 'Reinheit')
                                    "
                                    @reset-facet="resetFacet('Reinheit')"
                                />

                                <SearchFacet
                                    :checked="Listenpreis"
                                    :facet="searchState.facets.Listenpreis"
                                    :facet-title="'Price'"
                                    @change="
                                        handleFacetChange($event, 'Listenpreis')
                                    "
                                    @reset-facet="resetFacet('Listenpreis')"
                                />
                            </div>
                        </div>
                        <div class="flex justify-end mt-2 md:mt-4 h-7">
                            <button
                                class="btn-cb btn-small"
                                v-if="
                                    searchState.filters &&
                                    searchState.filters.length > 1
                                "
                                @click="resetAllFilters()"
                            >
                                Reset all filters
                                <i class="fas fa-times-circle"></i>
                            </button>
                        </div>
                    </div>
                    <div
                        class="flex flex-col md:flex-row justify-between items-start md:items-center gap-4"
                    >
                        <SearchPagingInfo
                            :search-state="searchState"
                            :current-results="currentResults"
                            :brand-name="brandName"
                            :searchTerm="searchInputValue"
                        />

                        <SearchSort v-show="thereAreResults" v-model="sortBy" />
                    </div>
                    <div class="">
                        <SearchResults
                            v-show="thereAreResults"
                            :results="searchState.results"
                        />

                        <button
                            @click="loadMore"
                            class="btn-cb mt-14"
                            v-if="
                                thereAreResults &&
                                searchState.totalResults > currentResults
                            "
                        >
                            Load more
                            <i class="fas fa-arrow-down"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { SearchDriver } from "@elastic/search-ui";
import config from "../../searchConfig";
import SearchResults from "./search-results.vue";
import SearchFacet from "./search-facet.vue";
import SearchHeaderBrand from "./search-header-brand.vue";
import SearchPagingInfo from "./search-paging-info.vue";
// import SearchPagination from "./SearchPagination.vue";
import SearchSort from "./search-sort.vue";
import SearchResultsPerPage from "./search-results-per-page.vue";

const driver = new SearchDriver(config);

export default {
    components: {
        SearchResults,
        SearchFacet,
        SearchHeaderBrand,
        SearchPagingInfo,
        // SearchPagination,
        SearchSort,
        SearchResultsPerPage,
    },
    props: {
        brand: {
            type: String,
            default: null,
        },
        brandName: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            searchInputValue: "",
            searchState: {},
            Name_des_Herstellers: [],
            Gruppenname: [],
            Verpackungsgruppe: [],
            VerkaufsME: [],
            Reinheit: [],
            Listenpreis: [],
            resultsPerPage: 20,
            currentResults: 20,
            sortBy: "relevance",
            suggestions: [],
        };
    },
    computed: {
        thereAreResults() {
            return (
                this.searchState.totalResults &&
                this.searchState.totalResults > 0
            );
        },
    },
    watch: {
        resultsPerPage(newResultsPerPage) {
            driver.setResultsPerPage(newResultsPerPage);
        },
        sortBy(newSortBy) {
            driver.setSort(newSortBy, "asc");
        },
    },
    mounted() {
        const { searchTerm, sortField, resultsPerPage, filters, facets } =
            driver.getState();

        // If a brand prop is provided, set it as a facet filter
        if (this.brand) {
            driver.addFilter("Name_des_Herstellers", this.brand, "any");
            this.Name_des_Herstellers = [this.brand];
        }

        // restoring UI from url query
        this.searchInputValue = searchTerm;
        this.sortBy = sortField;
        this.resultsPerPage = resultsPerPage;
        filters.forEach((filter) => {
            if (
                facets[filter.field] &&
                facets[filter.field].length > 0 &&
                facets[filter.field][0].type === "range"
            ) {
                this[filter.field] = filter.values.map((value) => value.name);
            } else {
                this[filter.field] = filter.values;
            }
        });

        driver.subscribeToStateChanges((state) => {
            this.searchState = state;
        });
    },
    methods: {
        handleFormSubmit() {
            // Get current state including filters before changing search term
            const currentState = driver.getState();
            const currentFilters = currentState.filters;

            // Set the new search term
            driver.getActions().setSearchTerm(this.searchInputValue);

            // Re-apply all existing filters after search term change
            if (currentFilters && currentFilters.length > 0) {
                currentFilters.forEach((filter) => {
                    filter.values.forEach((value) => {
                        driver.addFilter(filter.field, value, filter.type);
                    });
                });
            }
            driver.addFilter("Name_des_Herstellers", this.brand, "any");
        },
        handleFacetChange(event, facet) {
            const { value, checked } = event.target;
            const facetFromDriver = driver.getState().facets[facet];
            const valueforApi =
                facetFromDriver.type === "range"
                    ? facetFromDriver.data.find(
                          (item) => item.value.name === value,
                      ).value
                    : value;

            if (checked) {
                this[facet].push(value);
                driver.addFilter(facet, valueforApi, "any");
            } else {
                const index = this[facet].indexOf(value);
                if (index > -1) {
                    this[facet].splice(index, 1);
                }
                driver.removeFilter(facet, valueforApi, "any");
            }

            driver.addFilter("Name_des_Herstellers", this.brand, "any");
        },
        resetFacet(facet) {
            this[facet] = [];
            driver.removeFilter(facet);
        },
        setCurrentPage(page) {
            driver.setCurrent(page);
        },
        loadMore() {
            this.currentResults = this.currentResults + this.resultsPerPage;
            driver.setResultsPerPage(this.currentResults);
        },
        fetchAutocompleteSuggestions(searchTerm) {
            if (!searchTerm) {
                this.suggestions = [];
                return;
            }

            driver.getActions().setSearchTerm(searchTerm, {
                refresh: false,
                autocompleteResults: true,
            });

            driver.subscribeToStateChanges((state) => {
                if (state.autocompletedResults) {
                    this.suggestions = state.autocompletedResults.map(
                        (result) => result.Artikelbeschreibung.raw, // Adjust field name based on your schema
                    );
                }
            });
        },
        resetAllFilters() {
            const facets = Object.keys(this.searchState.facets);
            facets.forEach((facet) => {
                this.resetFacet(facet);
            });

            driver.addFilter("Name_des_Herstellers", this.brand, "any");
        },
    },
};
</script>
